import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  staffMembers: [],
  staff: null,
  staffDetails: null,
  success: false,
  error: null,
  message: null,
};

export const staffReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("createStaffRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("createStaffSuccess", (state, action) => {
      state.isLoading = false;
      state.staff = action.payload;
      state.success = true;
      state.error = null;
    })
    .addCase("createStaffFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase("getAllStaffRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getAllStaffSuccess", (state, action) => {
      state.isLoading = false;
      state.staffMembers = action.payload;
      state.error = null;
    })
    .addCase("getAllStaffFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("getStaffByIdRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getStaffByIdSuccess", (state, action) => {
      state.isLoading = false;
      state.staff = action.payload;
      state.error = null;
    })
    .addCase("getStaffByIdFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("editStaffRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("editStaffSuccess", (state, action) => {
      state.isLoading = false;
      state.staff = action.payload;
      state.success = true;
      state.error = null;
    })
    .addCase("editStaffFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase("deleteStaffRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("deleteStaffSuccess", (state, action) => {
      state.isLoading = false;
      state.staffMembers = state.staffMembers.filter((item) => item._id !== action.payload);
      state.success = true;
      state.message = "Staff deleted successfully!";
      state.error = null;
    })
    .addCase("deleteStaffFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});